import { render, staticRenderFns } from "./AssistantOptions.vue?vue&type=template&id=f683773e&scoped=true"
import script from "./AssistantOptions.vue?vue&type=script&lang=js"
export * from "./AssistantOptions.vue?vue&type=script&lang=js"
import style0 from "./AssistantOptions.vue?vue&type=style&index=0&id=f683773e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f683773e",
  null
  
)

export default component.exports